import { render, staticRenderFns } from "./fahuo.vue?vue&type=template&id=4e29a553&scoped=true"
import script from "./fahuo.vue?vue&type=script&lang=js"
export * from "./fahuo.vue?vue&type=script&lang=js"
import style0 from "./fahuo.vue?vue&type=style&index=0&id=4e29a553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29a553",
  null
  
)

export default component.exports